import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { getDistinctEnvironments } from 'src/apps/dashboard/services/distinct-environments/DistinctEnvironmentsService';
import { REFETCH_INTERVAL } from 'src/common/consts/QueryConfigs';
import { DASHBOARD_DISTINCT_ENVIRONMENTS } from 'src/common/providers/reactQueryProvider/QueryKeys';

export const useDistinctEnvironmentsQuery = (): UseQueryResult<string[], Error> => {
	return useQuery<string[], Error>({
		queryKey: [DASHBOARD_DISTINCT_ENVIRONMENTS],
		queryFn: getDistinctEnvironments,
		refetchInterval: REFETCH_INTERVAL
	});
};
